export default __webpack_public_path__ + "static/macworld_logo_shadowed-1c4ba322f66c9ca333af1fce9f5de649.png";